module.exports = __webpack_public_path__ + "static/media/sunset1.94061ba2.png";